<template>
  <div class="message-modal modal" ref="modal">
    <div class="progress" v-if="isProcessing">
      <div class="indeterminate"></div>
    </div>
    <div class="modal-content">
      <h4>Send Message</h4>
      <div>
        <div class="col s12">
          <div
            class="chip"
            v-for="(email, index) in message.emails"
            :key="index"
          >
            <i class="material-icons-outlined left">email</i>
            {{ email }}
          </div>
        </div>
        <div class="col s12 input">
          <label for="subject">Enter Subject</label>

          <input type="text" id="subject" v-model="message.subject" />
        </div>
        <div class="col s12 input">
          <label for="textarea">Enter Message</label>
          <textarea
            id="textarea"
            class="materialize-textarea"
            v-model="message.message"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="close()" class="waves-effect waves-blakc btn-flat">
        Close
      </button>
      <button
        @click="send()"
        :disabled="!isValid"
        class="waves-effect waves-green green-text btn-flat"
      >
        Send
      </button>
    </div>
  </div>
</template>
<script>
import { sendEmail } from "@/api/user.api";
import M from "materialize-css";
import { toastMessage } from "@/common/util";
export default {
  name: "MessageModal",
  props: {
    dataEmail: {
      type: String | Array,
    },
  },
  data() {
    let vm = this;
    return {
      instance: null,
      options: {
        onCloseEnd: () => {
          vm.close();
        },
      },
      message: {
        emails: null,
        subject: "",
        message: "",
      },
      isProcessing: false,
    };
  },
  computed: {
    isValid() {
      return Object.values(this.message).every((item) => item);
    },
  },
  beforeDestroy() {
    this.instance && this.instance.destroy();
  },
  mounted() {
    this.init();
    if (typeof this.dataEmail === "string") {
      this.message.emails = [];
      this.message.emails.push(this.dataEmail);
    } else {
      this.message.emails = this.dataEmail;
    }

    setTimeout(() => {
      M.updateTextFields();
    });
  },

  methods: {
    async init() {
      this.instance = M.Modal.init(this.$refs.modal, this.options);
      await this.$nextTick();

      this.instance.open();
    },
    close() {
      this.instance.close();
      this.$emit("close");
    },
    async send() {
      if (this.isProcessing || !this.isValid) return;
      this.isProcessing = true;

      try {
        let arr = [];

        this.message.emails.map((email) => {
          const payload = {
            email,
            subject: this.message.subject,
            message: this.message.message,
          };

          arr.push(sendEmail(payload, 4439));
        });

        await Promise.allSettled(arr);

        this.isProcessing = false;
        toastMessage("Message(s) Sent.");
      } catch (error) {
        this.isProcessing = false;
        toastMessage("Failed to send message");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.message-modal {
  .progress {
    position: absolute;
    top: 0;
    margin: 0;
  }

  .input {
    margin-top: 10px;
    label {
      font-size: 18px;
      font-weight: 500px;
    }
  }

  textarea {
    width: 100%;
  }
}
</style>
